<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'dictionary-color.detail', params: {id: id}}">Цвета одежды</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'dictionary-color.list'}">Цвета одежды</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>
          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активен"/>
          <gui-input v-model="data.name" :error="dataError.name" label="Название"/>
          <gui-input v-model="data.color" :error="dataError.color" label="Цвет">
            <template v-slot:after>
              <div class="input-group-append">
                <div class="input-group-text">
                  <i class="fas fa-circle" v-if="data.color && data.color.length == 6"
                     :style="{color: '#'+data.color}"></i>
                  <span v-else>
                    —
                  </span>
                </div>
              </div>
            </template>
          </gui-input>
          <gui-input v-model="data.contrast_color" :error="dataError.contrast_color"
                     label="Контрастный цвет, для галочки">
            <template v-slot:after>
              <div class="input-group-append">
                <div class="input-group-text">
                  <i class="fas fa-circle" v-if="data.contrast_color && data.contrast_color.length == 6"
                     :style="{color: '#'+data.contrast_color}"></i>
                  <span v-else>
                    —
                  </span>
                </div>
              </div>
            </template>
          </gui-input>
          <gui-input v-model="data.sort" :error="dataError.sort" label="Сортировка"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


export default {
  data() {
    return {
      data: null,
      dataDefault: {
        is_active: '',
        name: '',
        color: '',
        contrast_color: '',
        sort: 100,
      },
      dataError: {
        is_active: '',
        name: '',
        color: '',
        contrast_color: '',
        sort: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/dictionary-color/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/dictionary-color/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'dictionary-color.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/dictionary-color/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'dictionary-color.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>